// import jQuery from "jquery";
import 'slick-carousel';
import "./sass/style.scss";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
import objectFitImages from 'object-fit-images';
objectFitImages();
// BootstrapのJavaScript側の機能を読み込む
import bootstrap from 'bootstrap';
import MicroModal from 'micromodal';

// ドルマークに参照を代入(慣習的な $ を使うため)
const $ = jQuery;

$(function (){
  $(document).ready(function(){
    $('.wrap').addClass('ready');
  });
  $(window).on('load', function() {
    $('.wrap').addClass('comp');
    // heightResize();
  });
  $(window).resize(function() {
    // heightResize();
  });

  $('.firstView_slider').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    fade: true,
    cssEase: 'linear'
  });

  $('.gNav_toggle').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.gNav_overlay').toggleClass('open');
    if ($("body").css('overflow') == 'hidden') {
      $("body").css({ overflow: 'visible' });
    } else if ($("body").css('overflow') == 'visible') {
      $("body").css({ overflow: 'hidden' });
    };
  });

  $('.gNav_list_sub_toggle').on('click', function () {
    $(this).toggleClass('active');
    $(this).next('.gNav_list_sub').slideToggle();
  });

});
function checkBreakPoint() {
  const w = $(window).width();
  if (w <= 599) {
    // スマホ向け（767px以下のとき）
    $('.frontCenter_list').not('.slick-initialized').slick({
      dots: true,
      infinite: false,
      autoplay: false,
      speed: 300,
      fade: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  } else {
    // PC向け
    $('.frontCenter_list.slick-initialized').slick('unslick');
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function(){
  checkBreakPoint();
});
// 初回チェック
checkBreakPoint();


/* ----------------------------------
フェードイン アニメーション
---------------------------------- */

$(window).scroll(function (){
  $('.fadein').each(function(){
    var targetElement = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > targetElement - windowHeight + 100){
      $(this).css('opacity','1');
      $(this).css('transform','translateY(0)');
    }
  });
});


document.addEventListener("click", e => {
  const target = e.target;
  // clickした要素がclass属性、smooth-scrollを含まない場合は処理を中断
  if (!target.classList.contains("smooth-scroll")) return;
  e.preventDefault();
  const targetId = target.hash;
  const targetElement = document.querySelector(targetId);
  // 画面上部から要素までの距離
  const rectTop = targetElement.getBoundingClientRect().top;
  // 現在のスクロール距離
  const offsetTop = window.pageYOffset;
  // スクロール位置に持たせるバッファ
  const buffer = 120;
  const top = rectTop + offsetTop - buffer;
  console.log(top);

  window.scrollTo({
    top,
    behavior: "smooth"
  });
});

/* ----------------------------------
ローディング
---------------------------------- */

var loading = document.getElementById('loading');
/* 読み込み完了 */
window.addEventListener('load', stopload);

/* ロード画面を非表示にする処理 */
function stopload(){
  loading.classList.add('is-loaded');
}

/* 10秒経ったら強制的にロード画面を非表示にする */
setTimeout(stopload,10000, '');

document.addEventListener('DOMContentLoaded', function() {
});

MicroModal.init({
  openClass: 'is-open', // [5]
  disableScroll: true, // [6]
  disableFocus: false, // [7]
  awaitOpenAnimation: true, // [8]
  awaitCloseAnimation: true, // [9]
});